import { getSubName } from "@/utils/getHost";
/**
 * 问卷抽象类
 */
export interface ToolInterfaceQuestion {
  /**
   * @description: 排除掉页码、分页、联系我们之后真正排序
   * @param {*} params
   * @return {*}
   */
  getIndexName(index: any, type: any, data: any): any;
  /**
   * @description: 查找是否含有该类型
   * @param {*} params   subjectType
   * @return {*}
   */
  ishasQuestion(subjectType: any, listType: any, data: any): any;
  /**
   * @description: 根据问卷类型获取预览的跳转域名
   * @param {*} params   questionType
   * @return {*}
   */
  getQuestionPreviewUrl(questionType: any): any;
}
export class ToolQuestion implements ToolInterfaceQuestion {
  public getIndexName(
    index: any,
    addtype: any,
    data: any,
    typeList: any = [15, 16, 30, 31, 32, 35, 36]
  ) {
    const trueList: any = [];
    const list = data.slice(0, index); // 插入位置前面的列表
    list.forEach((element: any) => {
      if (typeList.indexOf(element.subjectType) === -1) {
        trueList.push(element.uuid);
      }
    });
    if (typeList.indexOf(addtype) > -1) {
      return null;
    } else {
      return trueList.length;
    }
  }
  public ishasQuestion(subjectType: any, listType: any, data: any) {
    if (
      listType.indexOf(subjectType) > -1 &&
      data &&
      data.filter((val: any) => val.subjectType === subjectType).length > 0
    ) {
      return true;
    }
    return false;
  }
  // 根据问卷类型获取预览的跳转域名
  public getQuestionPreviewUrl(questionType: any) {
    let baseUrl: any = "";
    if (getSubName() == "longyixiu") {
      if (process.env.NODE_ENV === "test") {
        baseUrl = "https://test.wj.longyixiu.vip";
      } else {
        switch (Number(questionType)) {
          case 1: // 调研
            baseUrl = "https://www.longyixiu.cn";
            break;
          case 2: // 考试
            baseUrl = "https://ks.longyixiu.cn";
            break;
          case 3: // 考试
            baseUrl = "https://ks.longyixiu.cn";
            break;
          case 4: // 表单
            baseUrl = "https://bd.longyixiu.net";
            break;
          case 5: // 接龙
            baseUrl = "https://jl.longyixiu.net";
            break;
          case 6: // 收款
            baseUrl = "https://jl.longyixiu.net";
            break;
          case 7: // 预约
            baseUrl = "https://bd.longyixiu.net";
            break;

          default:
            baseUrl = "https://www.longyixiu.cn";
            break;
        }
      }
    } else if (getSubName() == "wenjuanjia") {
      baseUrl = "https://wj.wenjuanjia.com";
    }
    return baseUrl;
  }
}
